import React, {useContext} from "react";
import Header from "../../../components/customer/LandingCustomer/Header";
import Body from "../../../components/customer/LandingCustomer/Body";
import Footer from "../../../components/customer/LandingCustomer/Footer";
import {useMediaQuery} from "react-responsive";
import HeaderMobile from "../../../components/customer/LandingCustomer/Mobile/HeaderMobile";
import BodyMobile from "../../../components/customer/LandingCustomer/Mobile/BodyMobile";
import FooterMobile from "../../../components/customer/LandingCustomer/Mobile/FooterMobile";
import AffinityContext from "../../../context/AffinityContext";
import {makeStyles} from '@material-ui/core/styles';
import InactiveBody from "../../../components/customer/LandingCustomer/InactiveBody";
import InactiveBodyMobile from "../../../components/customer/LandingCustomer/Mobile/InactiveBodyMobile";

const useStyles = makeStyles(theme => ({
    buttonContained: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        background: "#004285",
        padding: "6px 12px",
        marginLeft: "4px",
        marginRight: "4px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    mainColumnDiv: {
        width: "100vw",
        height: "100vh",
        backgroundColor: "#F5F6F9",
        display:"flex",
        flexDirection:"column",
        alignItems:"center"
    },
    headerDiv: {
        display: "flex",
        flexDirection: "row",
        alignSelf: "center",
        width: "100%",
        [theme.breakpoints.up('xl')]: {
            marginBottom: "32px",
        },
        [theme.breakpoints.down('xl')]: {
            marginBottom: "32px",
        },
        [theme.breakpoints.down('lg')]: {
            marginBottom: "16px",
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: "8px",
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: "8px",
        },
    },
    bodyDiv: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "center",
        [theme.breakpoints.up('xl')]: {
            height: "448px",
        },
        [theme.breakpoints.down('xl')]: {
            height: "400px",
        },
        [theme.breakpoints.down('lg')]: {
            height: "336px",
        },
        [theme.breakpoints.down('md')]: {
            height: "304px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "280px",
        },
    },
    footerDiv: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "50px",
        width: "100%",
        justifyContent: "center"
    },
}));

const LandingCustomer = (props) => {
    const classes = useStyles();
    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });

    const {
        affinityId,
        affinityInterCode,
        affinityPic,
        affinityActive
    } = useContext(AffinityContext);


    return (
        <>
            <div className={classes.mainColumnDiv}>
                <div className={classes.headerDiv}>
                    {isMobileDevice ? <HeaderMobile affinityPicture={affinityPic}/> :
                        <Header affinityPicture={affinityPic}/>}
                </div>

                {affinityActive
                    ?
                    <>
                        <div className={classes.bodyDiv}>
                            {isMobileDevice ? <BodyMobile/> : <Body/>}
                        </div>

                        <div className={classes.footerDiv}>
                            {isMobileDevice ? <FooterMobile affinityId={affinityId} CodigoProductor={affinityInterCode}/> :
                                <Footer affinityId={affinityId} CodigoProductor={affinityInterCode}/>}
                        </div>
                    </>
                    : <>
                        {isMobileDevice ?
                            <InactiveBodyMobile/> :
                            <InactiveBody/>}
                    </>
                }


            </div>
        </>

    );
};

export default LandingCustomer;
